/* eslint-disable react/function-component-definition */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import ParseContent from 'components/shared/ParseContent'
import HeroAlt from 'components/elements/HeroAlt'

const Content = styled.div`
  & h1 {
    text-align: left;
    color: #000000;
    font-style: normal;
    font-family: ${(props) => props.theme.font.family.secondary};
  }

  & h2,
  & h3 {
    font-family: ${(props) => props.theme.font.family.secondary};
    font-weight: bold;
    font-size: ${(props) => props.theme.font.size.xl};
  }

  & blockquote p {
    font-family: ${(props) => props.theme.font.family.secondary};
    font-size: ${(props) => props.theme.font.size.xl};
    color: ${(props) => props.theme.color.text.contrast};
    text-align: center;

    @media (min-width: 992px) {
      margin: 3rem 0;
    }
  }

  & .gatsby-image-wrapper img {
    position: relative !important;
  }

  & img[role='presentation'] {
    display: none !important;
  }
`

export const pageQuery = graphql`
  query ($id: String) {
    page: wpPost(id: { eq: $id }) {
      title
      uri
      content
      postRecap {
        banner {
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }
        story {
          description
        }
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { postRecap, seo },
  },
}) => (
  <Layout subFooter>
    {seo && <SEO seo={seo} />}
    <HeroAlt src={postRecap.banner.image} small>
      BAANBREKEND BOUWEN
    </HeroAlt>
    <section>
      <div className="container">
        <div className="row py-5">
          <div className="col-lg-2" />
          <div className="col-lg-8 py-3">
            <Content className="text-justify">
              <ParseContent content={postRecap.story.description} />
            </Content>
          </div>
          <div className="col-lg-2" />
        </div>
      </div>
    </section>
  </Layout>
)

export default PageTemplate
